import React, { useState, useRef, useEffect } from 'react';
import { Link } from "react-router-dom";
import { Button, Modal } from "react-bootstrap"; 
import axios from 'axios';
import Select from "react-select";
import default_img from '../../../../../images/product/productcategory.png';
import { toast } from 'react-toastify'; 
const AddProdCat = ({ show, onClose,refresh }) => { 
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const user_id = parseInt(localStorage.getItem("user_id"), 10);
    const [selectedOption, setSelectedOption] = useState(null);
    const [optionsSchedule, setOptionsSchedule] = useState([]); 

    const [file, setFile] = useState(null);    
    const [productCategoryName, setProductCategoryName] = useState('');
    const [description, setDescription] = useState('');
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const imageInputRef = useRef(null);
 
    useEffect(() => {
        const fetchSchedules = async () => {
            try {
                const response = await axios.get(`${baseURL}/item-schedule/items/active`);
                if (response.status === 200 && response.data.data) {
                    const schedules = response.data.data.map(item => ({
                        value: item.sno,
                        label: item.itemschedule_name,
                    }));
                    setOptionsSchedule(schedules);
                }
            } catch (error) {
                console.error('Error fetching schedules:', error);
            }
        };

        fetchSchedules();
    }, [baseURL]);

    const capitalizeWords = (str) => {
        return str.replace(/\b\w/g, (char) => char.toUpperCase());
    };

    const capitalizeFirstLetter = (str) => {
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    };

    const fileHandler = (e) => {
        const selectedFile = e.target.files[0];

        if (selectedFile) {
            const fileSize = selectedFile.size / 1024; // KB
            const validMimeTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];

            if (!validMimeTypes.includes(selectedFile.type)) {
                setErrors(prev => ({ ...prev, file: 'Only .jpeg, .png, .jpg, .gif formats are allowed.' }));
                setFile(null);
                return;
            }

            if (fileSize > 50) {
                setErrors(prev => ({ ...prev, file: 'Image size should not exceed 50 KB.' }));
                setFile(null);
                return;
            }

            setErrors(prev => ({ ...prev, file: null }));
            setFile(selectedFile);
        }
    };

    const RemoveImage = () => {
        setFile(null);
        if (imageInputRef.current) {
            imageInputRef.current.value = '';
        }
        setErrors(prev => ({ ...prev, file: null }));
    };

    const handleProductCategoryNameChange = (e) => {
        const value = capitalizeWords(e.target.value.toLowerCase());
        setProductCategoryName(value);
    };

    const handleDescriptionChange = (e) => {
        const value = capitalizeFirstLetter(e.target.value.trimStart());
        setDescription(value);
    };

    const validateForm = () => {
        const newErrors = {};

        if (!productCategoryName) {
            newErrors.productCategoryName = 'Product Category Name is required.';
        } else if (productCategoryName.length > 25) {
            newErrors.productCategoryName = 'Product Category Name cannot exceed 25 characters.';
        }

        if (description && description.length > 100) {
            newErrors.description = 'Description cannot exceed 100 characters.';
        }

        if (!selectedOption) {
            newErrors.schedule = 'Schedule selection is required.';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // const handleSubmit = async () => {
    //     if (!validateForm()) return;

    //     setLoading(true);

    //     const formData = new FormData();
    //     formData.append("productcategory_name", productCategoryName);
    //     formData.append("description", description);
    //     formData.append("schedule", selectedOption.value);
    //     if (file) {
    //         formData.append("productcategory_img", file);
    //     }

    //     try {
    //         const response = await axios.post(`${baseURL}/product-categories`, formData, {
    //             headers: { 'Content-Type': 'multipart/form-data' },
    //         });

    //         if (response.status === 201) {
    //             onClose();
    //             refresh();
    //             toast.success("Product created successfully!"); 
    //         }
    //     } catch (error) {
    //         if (error.response && error.response.status === 400) {
    //             const serverErrors = error.response.data.errors;
    //             const newErrors = {};
    //             if (serverErrors.productcategory_name) {
    //                 newErrors.productCategoryName = serverErrors.productcategory_name[0];
    //             }
    //             if (serverErrors.description) {
    //                 newErrors.description = serverErrors.description[0];
    //             }
    //             if (serverErrors.schedule) {
    //                 newErrors.schedule = serverErrors.schedule[0];
    //             }
    //             if (serverErrors.productcategory_img) {
    //                 newErrors.file = serverErrors.productcategory_img[0];
    //             }
    //             setErrors(newErrors);
    //         } else {
    //             console.error('Error adding product category:', error);
    //             toast.error("Failed to create product.");
    //         }
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    const handleSubmit = async () => {
    if (!validateForm()) return;

    setLoading(true);

    // Get branch_id and user_id from localStorage
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
    const user_id = parseInt(localStorage.getItem("user_id"), 10);

    // Build FormData
    const formData = new FormData();
    formData.append("productcategory_name", productCategoryName);
    formData.append("description", description);
    formData.append("schedule", selectedOption?.value || ""); // safe optional chaining
    formData.append("branch_id", branch_id || "");   // ✅ connect branch
    formData.append("created_by", user_id || "");    // ✅ connect user

    if (file) {
        formData.append("productcategory_img", file);
    }

    try {
        const response = await axios.post(`${baseURL}/product-categories`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });

        if (response.status === 201) {
            onClose();
            refresh();
            toast.success("Product category created successfully!");
        }
    } catch (error) {
        if (error.response && error.response.status === 400) {
            const serverErrors = error.response.data.errors;
            const newErrors = {};

            if (serverErrors.productcategory_name) {
                newErrors.productCategoryName = serverErrors.productcategory_name[0];
            }
            if (serverErrors.description) {
                newErrors.description = serverErrors.description[0];
            }
            if (serverErrors.schedule) {
                newErrors.schedule = serverErrors.schedule[0];
            }
            if (serverErrors.productcategory_img) {
                newErrors.file = serverErrors.productcategory_img[0];
            }

            setErrors(newErrors);
        } else {
            console.error("Error adding product category:", error);
            toast.error("Failed to create product.");
        }
    } finally {
        setLoading(false);
    }
};

    return (
        <Modal className="modal fade" show={show} size="md"> 
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Create Product Category</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span>×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">
                                Product Category <span className="required">*</span>
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Product Category"
                                value={productCategoryName}
                                // onChange={handleProductCategoryNameChange}
                                 onChange={(e) => {
                        const value = e.target.value;
                        if (/^[a-zA-Z\s]*$/.test(value) && value.length <= 25) {
                            handleProductCategoryNameChange(e);
                        }
                    }}
                            />
                            {errors.productCategoryName && (
                                <div className="text-danger mt-1 fs-8">{errors.productCategoryName}</div>
                            )}
                        </div>

                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">
                                Schedule <span className="required">*</span>
                            </label>
                            <Select
                                placeholder={'Select Schedule'}
                                value={selectedOption}
                                onChange={setSelectedOption}
                                options={optionsSchedule}
                            />
                            {errors.schedule && (
                                <div className="text-danger mt-1 fs-8">{errors.schedule}</div>
                            )}
                        </div>

                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Description</label>
                            <textarea
                                rows={8}
                                className="form-control"
                                placeholder="Description"
                                value={description}
                                onChange={handleDescriptionChange}
                                maxLength={100}
                            />
                            {errors.description && (
                                <div className="text-danger mt-1 fs-8">{errors.description}</div>
                            )}
                        </div>

                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7 d-block">Product Category Image</label>
                            <span className='fs-8 text-gray-800'>Size: </span>
                            <span className='fs-8 text-danger'>15 * 15</span>
                            <span className='fs-8 text-gray-800 ms-2'>Format: </span>
                            <span className='fs-8 text-danger'>.png, .jpg</span>
                            <div className="avatar-upload d-flex align-items-center">
                                <div className="change position-relative px-0">
                                    <div className="avatar-preview h-125px w-125px border" style={{ borderRadius: '10px' }}>
                                        <img
                                            id="saveImageFile"
                                            src={file ? URL.createObjectURL(file) : default_img}
                                            alt={file ? file.name : 'Default Avatar'}
                                            className="p-1 h-125px w-125px"
                                        />
                                    </div>
                                    <div className="change-btn">
                                        <input
                                            type="file"
                                            id="imageUpload"
                                            accept=".png, .jpg, .jpeg, .gif"
                                            style={{ display: 'none' }}
                                            onChange={fileHandler}
                                            ref={imageInputRef}
                                        />
                                        <div className="mt-2 d-flex justify-content-center">
                                            <Button
                                                className="btn-xs mb-2 me-2"
                                                variant="success"
                                                onClick={() => imageInputRef.current.click()}
                                            >
                                                <i className="fa fa-upload color-success fs-3" />
                                            </Button>
                                            <Button
                                                className="btn-xs mb-2 me-2"
                                                variant="danger"
                                                onClick={RemoveImage}
                                            >
                                                <i className="fa fa-close color-danger fs-3" />
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {errors.file && (
                                <div className="text-danger mt-1 fs-8">{errors.file}</div>
                            )}
                        </div>
                    </div>

                    <div className="d-flex align-items-center justify-content-center gap-3 mt-4">
                        <Link type="reset" className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</Link>
                        <Button
                            type="submit"
                            className="btn btn-sm btn-primary"
                            onClick={handleSubmit}
                            disabled={loading}
                        >
                            {loading ? 'Creating...' : 'Create Product Category'}
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default AddProdCat;
